"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeRightsArray = exports.readRightsArray = exports.standardEditRightsArray = exports.StandardRoleEnum = void 0;
const rights_enum_1 = require("./rights.enum");
var StandardRoleEnum;
(function (StandardRoleEnum) {
    StandardRoleEnum["ADMIN"] = "admin";
    StandardRoleEnum["AUDITOR"] = "auditor";
    StandardRoleEnum["APPROVER"] = "approver";
    StandardRoleEnum["EMPLOYEE"] = "employee";
})(StandardRoleEnum || (exports.StandardRoleEnum = StandardRoleEnum = {}));
/**
 * Standard rights are granted to a {@link Role} if {@link Role.hasNoWriteRights} is `false`
 */
exports.standardEditRightsArray = [rights_enum_1.RightEnum.INBOX_INVOICE__ALL__WRITE, rights_enum_1.RightEnum.EXPENSE__ALL__CREATE, rights_enum_1.RightEnum.VENDOR__ALL__CREATE_UNAPPROVED];
exports.readRightsArray = Object.values(rights_enum_1.RightEnum).filter((right) => right.endsWith("_READ"));
/**
 * All rights except read rights will be removed from a {@link Role} if {@link Role.hasNoWriteRights} is `true`
 */
exports.writeRightsArray = Object.values(rights_enum_1.RightEnum).filter((right) => !right.endsWith("_READ"));
